<template>
  <div class="al-c flex-box">
    <span style="line-height: 28px;">选择时间：</span>
    <el-button :type="btnType == 'yesterday' ? 'success' : ''" size="mini" @click="setDate('yesterday')">昨日</el-button>
    <el-button :type="btnType == 'today' ? 'success' : ''" size="mini" @click="setDate('today')">今日</el-button>
    <el-button :type="btnType == '7day' ? 'success' : ''" size="mini" @click="setDate('7day')">最近7日</el-button>
    <el-button :type="btnType == '30day' ? 'success' : ''" size="mini" @click="setDate('30day')">最近30日</el-button>
    <el-date-picker class="ml10" v-model="startDate" type="date" placeholder="选择开始时间" format="yyyy-MM-dd" value-format="timestamp" :picker-options="pickOptionForStart" @change="changeValue"></el-date-picker>
    <span class="ml10 mr10">至</span>
    <el-date-picker v-model="endDate" type="date" placeholder="选择结束时间" format="yyyy-MM-dd" value-format="timestamp" default-time="23:59:59" :picker-options="pickOptionForEnd" @change="changeValue"></el-date-picker>
  </div>
</template>

<script>
export default {
  name: "DateComp",
  components: {},
  props: ["loading"],
  data() {
    return {
      btnType: "30day",
      startDate: Date.now() - 3600000 * 24 * 30,
      endDate: Date.now(),
      minDate: null,
      pickOptionForStart: {
        disabledDate: time => {
          if (this.endDate) {
            return (
              (time.getTime() > this.endDate ? true : false) ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickOptionForEnd: {
        disabledDate: time => {
          if (this.startDate) {
            return (
              (time.getTime() < this.startDate ? true : false) ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        }
      }
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    setDate(btnType) {
      this.btnType = btnType;
      switch (btnType) {
        case "yesterday":
          this.startDate = Date.now() - 3600000 * 24;
          this.endDate = Date.now() - 3600000 * 24;
          break;
        case "today":
          this.startDate = Date.now();
          this.endDate = Date.now();
          break;
        case "7day":
          this.startDate = Date.now() - 3600000 * 24 * 7;
          this.endDate = Date.now();
          break;
        case "30day":
          this.startDate = Date.now() - 3600000 * 24 * 30;
          this.endDate = Date.now();
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.$emit("change", [this.startDate, this.endDate]);
          this.$emit("changehandle", [this.timestampToTime(this.startDate),
              this.timestampToTime(this.endDate)]);
      });
    },
    changeValue(value) {
      this.btnType = "other";
      // if (value && value.length) {
      //   this.$emit("change", [
      //     this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
      //     this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
      //   ]);
      // }
    },
    getValue() {
      let startDate = this.startDate || Date.now() - 86400000 * 30;
      let endDate = this.endDate || Date.now();
      endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
      return [startDate, endDate];
    },
      getValueStr() {
          let startDate = this.startDate || Date.now() - 86400000 * 30;
          let endDate = this.endDate || Date.now();
          endDate = this.btnType == "other" ? endDate + 86399000 : endDate;

          return [this.timestampToTime(startDate), this.timestampToTime(this.timestampToTime(endDate))];
      },
      timestampToTime(timestamp) {
      let date = new Date(timestamp);
          let Y = date.getFullYear() + '-';
          let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          let D = date.getDate() < 10 ?  '0'+date.getDate()+ ' ' : date.getDate()+ ' ';
    return Y+M+D
}

}
};
</script>

<style scoped>
.title::before,
.title::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  width: 100px;
  height: 1px;
  background: #475eb7;
}

.title::before {
  right: 130%;
}

.title::after {
  left: 130%;
}
</style>
